<template lang="html">
  <v-layout column class="content-container">
    <signature-pad-dialog
      :key="currentSignatureIndex"
      :opened.sync="signaturePadOpened"
      :signatureType.sync="signatureType"
      :image-signature.sync="imageSignature"
      :image-raw-data.sync="imageRawData"
      :text-signature.sync="textSignature"
      @saveSignature="saveSignature"
    />

    <v-layout row justify-center align-center class="tab-container">
      <sc-button-group>
        <sc-button
          type="secondary"
          @click="backToDashboard"
          size="small"
          icon-left="arrow-left"
          :is-round="true"
          :is-icon-only="true"
        >
        </sc-button>
      </sc-button-group>

      <v-tabs centered class="tabs" color="transparent" v-model="activeTab">
        <v-tab>
          <h2 class="hidden-md-and-down">Review & Sign</h2>
          <h3 class="hidden-lg-and-up">Review & Sign</h3>
        </v-tab>
        <!--
        <v-tab>
          <h2 class="hidden-md-and-down">2. Download</h2>
          <h3 class="hidden-lg-and-up">2. Download</h3>
        </v-tab>
        -->
      </v-tabs>
    </v-layout>

    <v-layout v-if="activeTab === 0" class="return-container">
      <v-layout class="sidebar column text-xs-left hidden-md-and-down">
        <h4 class="mb-2">Pages to sign:</h4>

        <ul class="page-list">
          <li v-for="page in pagesContainSignatures">
            <a
              @click="currentPage = page"
              :style="
                currentPage === page ? 'font-weight: bold; color: #4f7eea;' : ''
              "
            >
              Page {{ page }}
              <v-icon
                small
                color="success"
                v-if="
                  signatures
                    .filter(s => s.page === page && s.userId === currentUser.id)
                    .every(s => s.signatureData)
                "
                >check</v-icon
              >
            </a>
          </li>
        </ul>
      </v-layout>

      <div class="pdf-container">
        <v-alert
          v-if="
            currentSignatureRequest &&
              currentSignatureRequest.status === 'completed'
          "
          class="ma-0 alert"
          :value="true"
          color="success"
          >This signature request is marked as completed. No further action
          needed.</v-alert
        >
        <v-alert
          v-else-if="signedAll === true"
          class="ma-0 alert"
          :value="true"
          color="success"
          >You have finished signing this document.
          <span
            v-if="currentSignatureRequest && currentSignatureRequest.section_id"
            >Please <a @click="$router.go(-1)">click here</a> to go back.</span
          ><span v-else>You can close this webpage.</span></v-alert
        >
        <v-alert v-else class="ma-0 alert" :value="true"
          >Some pages require your signatures.</v-alert
        >

        <v-layout class="toolbar" justify-center>
          <div class="d-flex align-center">
            <v-icon
              class="grey--text text--darken-1 mr-1"
              style="cursor: pointer"
              @click="currentPage -= 1"
              :disabled="currentPage === 1"
              large
              >keyboard_arrow_left</v-icon
            >

            <v-layout
              class="grey--text text--darken-3 subheading font-weight-bold"
              align-center
              shrink
            >
              Page:
              <v-text-field
                type="number"
                :value="currentPage"
                class="page-input mx-2"
                solo
                @change="currentPage = parseInt($event)"
                hide-details
              />
              / {{ pageCount }}
            </v-layout>

            <v-icon
              class="grey--text text--darken-1 mx-1"
              style="cursor: pointer"
              @click="currentPage += 1"
              :disabled="currentPage === pageCount"
              large
              >keyboard_arrow_right</v-icon
            >
          </div>
        </v-layout>

        <v-container class="pdf">
          <pdf
            @num-pages="pageCount = $event"
            @page-loaded="
              currentPage = $event;
              previewLoading = false;
              pdfLoaded = true;
            "
            @progress="pdfProgress = $event"
            :page="currentPage"
            :src="pdfSrc"
          />

          <v-layout
            v-if="
              pdfLoaded &&
                currentSignatureRequest &&
                !currentSignatureRequest.signed_document &&
                currentSignatureRequest.status !== 'completed'
            "
            v-for="(signature, index) in signatures"
            :key="index"
          >
            <v-layout
              v-if="signature.page === currentPage"
              class="signature-container"
              :style="
                'bottom:' +
                  signature.signatureBottom +
                  'px;left:' +
                  signature.signatureLeft +
                  'px'
              "
            >
              <img
                v-if="signature.signatureType === 'image'"
                :style="
                  'width:' +
                    signature.signatureWidth +
                    'px; height:' +
                    signature.signatureHeight +
                    'px'
                "
                :src="signature.signatureData"
              />

              <v-layout
                v-else-if="signature.signatureType === 'text'"
                align-center
                justify-center
                :style="
                  'width:' +
                    signature.signatureWidth +
                    'px; height:' +
                    signature.signatureHeight +
                    'px'
                "
              >
                <span
                  class="signature-text"
                  :style="'font-size:' + signature.signatureTextSize + 'px'"
                >
                  {{ signature.signatureData }}
                </span>
              </v-layout>

              <v-layout
                v-else-if="signature.userId === currentUser.id"
                align-center
                justify-center
                :style="
                  'width:' +
                    signature.signatureWidth +
                    'px; height:' +
                    signature.signatureHeight +
                    'px'
                "
              >
                <v-btn
                  color="info"
                  block
                  class="sign-here-button text-capitalize"
                  @click="openSignaturePad(index)"
                  :style="
                    'font-size:' + (signature.signatureTextSize - 12) + 'px'
                  "
                >
                  Click here to sign <br />({{ signature.title }})
                </v-btn>
              </v-layout>
            </v-layout>

            <v-layout
              v-if="signature.page === currentPage && signature.signatureDate"
              class="signature-date-container"
              :style="
                'bottom:' +
                  signature.signatureDateBottom +
                  'px; left:' +
                  signature.signatureDateLeft +
                  'px'
              "
            >
              <span
                class="signature-date"
                :style="
                  'font-size:' + (signature.signatureTextSize - 10) + 'px'
                "
              >
                {{ signature.signatureDate }}
              </span>
            </v-layout>
          </v-layout>
        </v-container>
      </div>
    </v-layout>

    <v-layout v-else-if="activeTab === 1" column justify-center align-center>
      <v-container class="download-container ma-0" grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-btn
              solo
              class="d-flex download-btn text-none"
              @click="downloadPdf(false)"
            >
              <v-icon color="primary">download</v-icon>
              <span class="pl-2"
                >Download a copy <b>without</b> signatures.</span
              >
            </v-btn>
          </v-flex>

          <v-flex xs12 md6>
            <v-tooltip
              bottom
              :disabled="currentSignatureRequest.signed_document"
            >
              <v-btn
                slot="activator"
                solo
                class="d-flex download-btn text-none"
                :disabled="!currentSignatureRequest.signed_document"
                @click="downloadPdf(true)"
              >
                <v-icon color="primary">download</v-icon>
                <span class="pl-2"
                  >Download a copy <b>with</b> signatures.</span
                >
              </v-btn>
              <span
                >The signed document is not ready for download. Please come back
                later.</span
              >
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </v-layout>
</template>

<script>
import moment from 'moment';
import pdf from 'vue-pdf';
import { mapState, mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import uniq from 'lodash/uniq';
import API from '@/api';
import SignaturePadDialog from '@/components/dialogs/SignaturePadDialog';
import download from 'downloadjs';

export default {
  name: 'TaxReturn',

  components: {
    pdf,
    SignaturePadDialog,
  },

  props: {},

  data() {
    return {
      activeTab: 0,
      previewLoading: false,
      currentPage: 1,
      pdfLoaded: false,
      pdfProgress: 0,
      pdfSrc: '',
      pageCount: 1,
      currentSignatureRequest: null,

      signatureType: 'image',
      signaturePadOpened: false,
      currentSignatureIndex: null,

      imageSignature: '',
      textSignature: '',

      signatures: [],

      savedSignaturesByTitle: {},
    };
  },

  computed: {
    ...mapGetters({
      currentUser: 'user',
      isAdvisor: 'isAdvisor',
    }),

    pagesContainSignatures() {
      return uniq(this.signatures.map(s => s.page).sort((a, b) => a - b));
    },

    currentSignatureRequestId() {
      return this.$route.query.id;
    },

    signedAll() {
      if (!this.pdfLoaded || this.previewLoading) {
        return false;
      }

      const requiredSignatures = this.signatures.filter(
        s => s.userId === this.currentUser.id,
      );

      if (requiredSignatures.length > 0) {
        return requiredSignatures.every(s => s.signatureData);
      } else {
        return true;
      }
    },
  },

  methods: {
    openSignaturePad(signatureIndex) {
      this.signaturePadOpened = true;
      this.currentSignatureIndex = signatureIndex;

      const signature = this.signatures[signatureIndex];
      const savedSignature = this.savedSignaturesByTitle[signature.title];

      this.signatureType = savedSignature
        ? savedSignature.signatureType
        : 'image';
      this.imageSignature =
        savedSignature && savedSignature.signatureType === 'image'
          ? savedSignature.signatureData
          : '';
      this.textSignature =
        savedSignature && savedSignature.signatureType === 'text'
          ? savedSignature.signatureData
          : '';
    },

    async saveSignature() {
      this.signaturePadOpened = false;

      const signature = {
        ...this.signatures[this.currentSignatureIndex],
        signatureType: this.signatureType,
        signatureData:
          this.signatureType === 'image'
            ? this.imageSignature
            : this.textSignature,
        signatureDate: moment().format('L'),
      };

      // Retained signature for re-use across pages
      this.savedSignaturesByTitle[signature.title] = {
        signatureType: this.signatureType,
        signatureData:
          this.signatureType === 'image'
            ? this.imageSignature
            : this.textSignature,
      };

      const response = await API.signatureRequest.saveSignature({
        id: this.currentSignatureRequestId,
        companyId: this.currentCompanyId,
        signature: signature,
      });

      this.signatures = response.data.signatures;

      if (response.data.error) {
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem signing the document.',
          errorToSend: e,
          userEmail: this.currentUser.email,
        });
      }
    },

    renderSignatures() {
      const pdfContainer = document.querySelector('.pdf');
      const {
        width: pageWidth,
        height: pageHeight,
      } = pdfContainer.getBoundingClientRect();

      this.signatures = this.signatures.map(signature => {
        const ratio = pageWidth / signature.pageWidth;

        return {
          ...signature,
          pageWidth,
          pageHeight,
          signatureWidth: signature.signatureWidth * ratio,
          signatureHeight: signature.signatureHeight * ratio,
          signatureBottom: signature.signatureBottom * ratio,
          signatureLeft: signature.signatureLeft * ratio,
          signatureTextSize: signature.signatureTextSize * ratio,
          signatureDateBottom: signature.signatureDateBottom * ratio,
          signatureDateLeft: signature.signatureDateLeft * ratio,
        };
      });
    },

    async downloadPdf(includeSignatures) {
      try {
        const response = await API.signatureRequest.downloadPdf({
          id: this.currentSignatureRequest.id,
          companyId: this.currentSignatureRequest.company_id,
          includeSignatures,
        });

        const name = this.currentSignatureRequest.form_name.endsWith('.pdf')
          ? this.currentSignatureRequest.form_name
          : this.currentSignatureRequest.form_name + '.pdf';

        this.downloadDocumentByLink(response.data.document.data.link, name);
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem downloading the document.',
        });
      }
    },

    async downloadDocumentByLink(url, name) {
      let response = await this.$http.get(url, { responseType: 'arraybuffer' });
      let blob = new Blob([response.data], {
        type: get(response.headers, 'content-type'),
      });
      download(blob, name, get(response.headers, 'content-type'));
    },

    backToDashboard() {
      if (this.isEmbeddedInNext) {
        window.location.href = '/';
      } else {
        this.$router.push({ name: 'dashboard' });
      }
    },
  },

  async beforeDestroy() {
    window.removeEventListener('resize', this.renderSignatures);
  },

  async created() {
    try {
      if (this.$route.query.companyId) {
        this.currentCompanyId = parseInt(this.$route.query.companyId);
      } else if (this.$route.params.hash) {
        const hash = this.$route.params.hash;
        const hashId = hash.substring(hash.lastIndexOf('-') + 1);
        try {
          const { data } = await API.company.getCompanyIdByHashId(hashId);

          this.currentCompanyId = data.id;
        } catch (error) {
          this.$router.push('/select-entity');
        }
      } else {
        this.currentCompanyId = this.defaultCompany.id;
      }

      const { data: company } = await API.company.getCompany(
        this.currentCompanyId,
      );

      if (company.inactive) {
        this.$router.push('/select-entity');
      } else {
        await this.$store.dispatch('resetTiles', {
          companyId: this.currentCompanyId,
        });

        const { data } = await API.signatureRequest.getSignatureRequest({
          id: this.currentSignatureRequestId,
          companyId: this.currentCompanyId,
        });

        this.currentSignatureRequest = data;

        const response = await API.integration.downloadDocument({
          companyId: this.currentCompanyId,
          link: data.signed_document
            ? data.signed_document
            : data.include_watermark
            ? data.watermarked_document
            : data.source,
        });

        window.addEventListener('resize', this.renderSignatures);

        if (response.data.document) {
          this.pdfSrc = response.data.document.data.link;
          this.pdfLoaded = true;

          if (data.signatures !== null) {
            this.signatures = data.signatures;
            this.renderSignatures();
          }
        } else {
          this.$store.dispatch('application/setErrorNotification', {
            message: 'There was a problem viewing the document.',
            errorToSend: response.data.error,
            userEmail: this.currentUser.email,
          });
        }
      }
    } catch (e) {
      console.log(e);
      this.$store.dispatch('application/setErrorNotification', {
        message: 'There was a problem viewing the document.',
        errorToSend: e,
        userEmail: this.currentUser.email,
      });
    }
  },
};
</script>

<style lang="postcss" scoped>
.content-container {
  height: calc(100vh);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.tab-container {
  flex: 0;
  gap: 20px;
  border-bottom: 1px solid #ccc;
}

.tabs {
  & >>> .v-tabs__item {
    padding: 20px 40px;
    text-transform: none;
  }
}

.return-container {
  min-height: 0;
}

.sidebar {
  overflow: auto;
  min-width: 260px;
  font-size: 16px;
  flex: 0;
  padding: 20px;
  border-right: 1px solid #ccc;
}

.pdf-container {
  overflow: auto;
  flex: auto;
  background-color: #e7e9ef;
}

.pdf {
  position: relative;
  max-width: 1000px;
  padding: 0;
}

.page-list li {
  padding: 6px 0px;
}

.alert {
  position: sticky;
  top: 0;
  z-index: 1;
  height: 44px;
}

.toolbar {
  border-bottom: 1px solid #bbb;
  padding: 8px 16px;
  justify-content: center;
  background-color: #e7e9ef;
  position: sticky;
  top: 44px;
  z-index: 1;
}

.page-input >>> .v-input__control .v-input__slot {
  border-radius: 4px;
}

.page-input >>> .v-input__control {
  min-height: 20px;
}

.page-input >>> input {
  width: 32px;
}

.page-input >>> input::-webkit-outer-spin-button,
.page-input >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.page-input >>> input[type='number'] {
  -moz-appearance: textfield;
}

.download-container {
  max-width: 540px;
  flex: 0;
}

.download-btn {
  cursor: pointer;
  padding: 16px 20px;
  margin: 0;
  border: 1px solid #ccc;
  background: #fff !important;
  border-radius: 8px;
  font-size: 16px;
  box-shadow: none;
  height: auto;
  width: 100%;

  &:hover {
    background: #f7f7f7;
  }
  & >>> .v-btn__content {
    white-space: pre-line;
  }
}

.signature-container {
  position: absolute;
}

.signature-date-container {
  position: absolute;
}

.signature-text {
  font-family: 'Zeyada', cursive;
}

.signature-date {
  font-family: 'Mali', cursive;
}

.sign-here-button {
  cursor: pointer;
  opacity: 0.9;
  width: 25%;
  height: 65%;
  width: 100%;
}
</style>
